"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBDialog = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var CloseIcon_1 = require("../Icons/CloseIcon");
var MBText_1 = require("../MBText");
var MBIconButton_1 = require("../MBIconButton");
var MBButton_1 = require("../MBButton");
var mock_1 = require("../../utils/mock");
var StyledDialog = styled_components_1.default(function (_a) {
    var maxWidth = _a.maxWidth, width = _a.width, height = _a.height, maxHeight = _a.maxHeight, background = _a.background, overflow = _a.overflow, rest = __rest(_a, ["maxWidth", "width", "height", "maxHeight", "background", "overflow"]);
    mock_1.mockFunction({ maxWidth: maxWidth, width: width, height: height, maxHeight: maxHeight, background: background, overflow: overflow });
    return jsx_runtime_1.jsx(Dialog_1.default, __assign({}, rest), void 0);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .MuiDialog-paper {\n    width: ", ";\n    max-width: ", ";\n    height: ", ";\n    max-height: ", ";\n    position: relative;\n    overflow: ", ";\n    display: flex;\n    ", "\n  }\n\n  .MuiPaper-rounded {\n    border-radius: 4px;\n    border: 1px solid #000000;\n    box-shadow: 5px 5px 0px 0px rgba(0, 0, 0, 0.2);\n  }\n"], ["\n  & .MuiDialog-paper {\n    width: ", ";\n    max-width: ",
    ";\n    height: ",
    ";\n    max-height: ",
    ";\n    position: relative;\n    overflow: ", ";\n    display: flex;\n    ", "\n  }\n\n  .MuiPaper-rounded {\n    border-radius: 4px;\n    border: 1px solid #000000;\n    box-shadow: 5px 5px 0px 0px rgba(0, 0, 0, 0.2);\n  }\n"])), function (_a) {
    var width = _a.width;
    return (typeof width === 'number' ? width + "px" : width);
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return typeof maxWidth === 'number' ? maxWidth + "px" : maxWidth;
}, function (_a) {
    var height = _a.height;
    return typeof height === 'number' ? height + "px" : height;
}, function (_a) {
    var maxHeight = _a.maxHeight;
    return typeof maxHeight === 'number' ? maxHeight + "px" : maxHeight;
}, function (_a) {
    var overflow = _a.overflow;
    return overflow;
}, function (_a) {
    var background = _a.background;
    return background && "background: " + background + ";";
});
var MBDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, children = _a.children, title = _a.title, unmountOnClosed = _a.unmountOnClosed, _b = _a.maxWidth, maxWidth = _b === void 0 ? 600 : _b, _c = _a.width, width = _c === void 0 ? '100%' : _c, _d = _a.background, background = _d === void 0 ? '#fff' : _d, maxHeight = _a.maxHeight, height = _a.height, _e = _a.showHeader, showHeader = _e === void 0 ? true : _e, _f = _a.showOutsideClose, showOutsideClose = _f === void 0 ? false : _f, _g = _a.overflow, overflow = _g === void 0 ? 'visible' : _g;
    var _h = __read(react_1.useState(open), 2), mount = _h[0], setMount = _h[1];
    react_1.useEffect(function () {
        if (open) {
            setMount(open);
        }
        else {
            var handleMount_1 = setTimeout(function () {
                setMount(open);
            }, 1000);
            return function () {
                clearTimeout(handleMount_1);
            };
        }
    }, [open]);
    /* this is to prevent Dialog components to be rendered even without being opened yet */
    if (!mount && unmountOnClosed) {
        return null;
    }
    return (jsx_runtime_1.jsxs(StyledDialog, __assign({ width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, background: background, open: open, onClose: onClose, overflow: overflow }, { children: [showOutsideClose && (jsx_runtime_1.jsx(core_1.Box, __assign({ position: "absolute", right: "-16px", top: "-48px" }, { children: jsx_runtime_1.jsxs(MBButton_1.MBButton, __assign({ fullWidth: true, borderRadius: 0, border: "none", onClick: onClose, background: "transparent", hoverVariant: MBButton_1.IMBButtonHoverVariant.highlight, color: "#fff" }, { children: [jsx_runtime_1.jsx(MBText_1.MBText, { t: "common:buttons.close", mr: 0.5 }, void 0),
                        jsx_runtime_1.jsx(CloseIcon_1.CloseIcon, { stroke: "white", size: 20 }, void 0)] }), void 0) }), void 0)),
            jsx_runtime_1.jsxs(core_1.Box, __assign({ display: "flex", flexDirection: "column", overflow: "scroll", flex: 1 }, { children: [showHeader && (jsx_runtime_1.jsxs(core_1.Box, __assign({ px: 2, pt: 2, height: 24, position: "relative", mb: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }, { children: [jsx_runtime_1.jsx(core_1.Box, { children: title }, void 0),
                            jsx_runtime_1.jsx(core_1.Box, { children: jsx_runtime_1.jsx(MBIconButton_1.MBIconButton, { onClick: onClose, padding: 0, Icon: { component: CloseIcon_1.CloseIcon } }, void 0) }, void 0)] }), void 0)), children] }), void 0)] }), void 0));
};
exports.MBDialog = MBDialog;
var templateObject_1;
//# sourceMappingURL=MBDialog.js.map